<ng-container *ngIf="annuncioObj">
    <div class="ricercheRecenti__cont" [class.isPrint]="this.isPrint" [class.historical]="this.annuncioObj?.historical"
        [class.hasBg]="this.annuncioObj?.historical && this.publicImages && this.publicImages[0] && this.publicImages[0].url"
        [class.pb-3]="!isHome">
        <div class="imgCover">
            <div class="imgCont position-relative">
                <div *ngIf="this.annuncioObj?.isSuperTop || this.annuncioObj?.isTop" class="badgeContainer">
                    <app-badge
                        [badgeType]="this.annuncioObj?.isSuperTop ? 'super top' : this.annuncioObj?.isTop ? 'top' : ''"></app-badge>
                </div>


                <img [ngSrc]="this.main.generatePictureUrl(this.imageAnnuncio(), '360', 'house')" class="listing-img"
                    [alt]="this.publicImages[this.imgIndex]?.alt" onerror="this.style.display='none'" fill="center">

                <ng-container
                    *ngIf="this.annuncioObj?.status!=='sold' && this.annuncioObj?.status!=='rented' && this.annuncioObj.mandate_type!=='in-esclusiva-non-verificata' && !this.annuncioObj.is_auction">
                    <div class="nuovo-annuncio" *ngIf="this.main?.getDays(annuncioObj?.created_at, true)">
                        <p class="p-0 m-0">Nuovo Annuncio</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="this.annuncioObj?.status!=='sold' && this.annuncioObj?.status!=='rented'">
                    <div class="nuovo-annuncio"
                        *ngIf="this.annuncioObj.mandate_type==='in-esclusiva-non-verificata' && !this.annuncioObj.is_auction">
                        <p class="p-0 m-0">In esclusiva</p>
                    </div>
                    <div class="nuovo-annuncio"
                        *ngIf="this.annuncioObj.mandate_type==='in-esclusiva' && showMandateType() && !this.annuncioObj.is_auction">
                        <p class="p-0 m-0"><i class="icon-star me-1"> </i>Esclusiva verificata</p>
                    </div>
                    <div class="nuovo-annuncio asta" *ngIf="this.annuncioObj?.is_auction">
                        <p class="p-0 m-0">Asta</p>
                    </div>
                </ng-container>
                <div class="nuovo-annuncio" *ngIf="this.annuncioObj?.status==='sold'">
                    <p class="p-0 m-0">Venduto</p>
                </div>
                <div class="nuovo-annuncio" *ngIf="this.annuncioObj?.status==='rented'">
                    <p class="p-0 m-0">Affittato</p>
                </div>
                <div class="patina" (click)="this.main?.linkBlank(this.generateurl())">
                </div>
                <div *ngIf="this.publicImages.length > 1 && !this.isHome" class="sliderControlsCont">
                    <div (click)="decrementImgCount(this.publicImages.length-1)" class="left-slide">
                        <i class="icon-chevron-left"></i>
                    </div>
                    <div (click)="incrementImgCount(this.publicImages.length-1)" class="right-slide">
                        <i class="icon-chevron-right"></i>
                    </div>
                </div>
                <div class="acr-listing-icons p-0 m-0 mt-0 mb-2"
                    (click)="this.main?.linkBlank(this.generateUrl()); $event.stopPropagation(); listingObjToLocStorage()">
                    <div *ngIf="annuncioObj?.bedrooms > 0" class="acr-listing-icon me-4" data-toggle="tooltip" title=""
                        data-original-title="Beds">
                        <i class="icon-bed m-0"></i>
                        <span class="acr-listing-icon-value fw-normal ms-2">{{annuncioObj?.bedrooms}}</span>
                    </div>
                    <div *ngIf="annuncioObj?.bathrooms > 0" class="acr-listing-icon me-4" data-toggle="tooltip" title=""
                        data-original-title="Bathrooms">
                        <i class="icon-bath m-0"></i>
                        <span class="acr-listing-icon-value fw-normal ms-2">{{annuncioObj?.bathrooms}}</span>
                    </div>
                    <div *ngIf="this.main?.returnSmallFloor(annuncioObj?.floors)" class="acr-listing-icon me-4"
                        data-toggle="tooltip" title="" data-original-title="Stairs">
                        <img [ngSrc]="'../../../../assets/img/stairsCostom-white.svg'" width="15" height="13"
                            class="stairsIcon" alt="icona scala">
                        <span
                            class="acr-listing-icon-value fw-normal ms-2">{{this.main?.returnSmallFloor(annuncioObj?.floors)}}</span>
                    </div>
                    <div *ngIf="annuncioObj?.surface" class="acr-listing-icon me-4" data-toggle="tooltip" title=""
                        data-original-title="Square Feet">
                        <i class="icon-ruler-combined m-0"></i>
                        <span *ngIf="annuncioObj?.surface"
                            class="acr-listing-icon-value fw-normal ms-2">{{annuncioObj?.surface | number }}
                            &#13217;</span>
                        <span *ngIf="!annuncioObj?.surface" class="acr-listing-icon-value fw-normal ms-2"> -
                            &#13217;</span>
                    </div>
                </div>

                <ng-container
                    *ngIf="this.imageAnnuncio() && this.main.checkIfPatinaNeeded(this.imageAnnuncio().split('.com')[0])"><!-- this.imageAnnuncio().split('.com')[0] !== this.oldImgUrl -->
                    <div class="patinaOldLogoCont noRightClick">
                        <div class="patinaOldLogo noRightClick"></div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div [style.background-color]="annuncioObj?.agency?.color || '#166FC1'" class="detailAgent"
            (click)="this.main?.linkBlank(this.generateurl())">
            <div class="detailAgent__cont">
                <div class="detailAgent__cont--left">
                    <div class="agentImgAndRating">
                        <div class="smallImgAgent position-relative">
                            <img [ngSrc]="this.main.generatePictureUrl(this.annuncioObj.agent.member.profile_img, '60', 'agent')"
                                fill="center"
                                [alt]="'Immagine profilo ' + annuncioObj?.agent?.member?.first_name + ' ' + annuncioObj?.agent?.member?.last_name">
                        </div>
                    </div>
                    <div class="rating">
                        <div class="d-flex align-items-center">
                            <p class="agent-name p-0 m-0 me-2">{{(annuncioObj?.agent?.member?.first_name || 'Nome') |
                                titlecase}} {{(annuncioObj?.agent?.member?.last_name || 'Cognome') | titlecase}}</p>
                            <app-badge *ngIf="annuncioObj?.agent?.isTop" [showText]="false"
                                [badgeType]="'agente-top'"></app-badge>
                        </div>

                        <p class="agency-name p-0 m-0">{{annuncioObj?.agency?.name }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="detailCont" (click)="this.main?.linkBlank(this.generateurl())">
            <p [class.title-annuncio--twoLine]="isHome" class="title-annuncio m-0 mt-2">{{annuncioObj?.title ||
                'Titolo'}}</p>

            <div class="d-flex">
                <p *ngIf="annuncioObj?.city" class="subtitle-annuncio m-0 fw-normal text-uppercase w-50">
                    {{annuncioObj?.city}}</p>
            </div>
            <ng-container *ngIf="showPrice && !this.annuncioObj.historical">
                <p *ngIf="annuncioObj?.private_negotiation; else notPrivate" class="price"
                    routerLink="/{{this.main.generateRouteByContractAndStatus(annuncioObj)}}/{{annuncioObj?.slug}}">
                    Prezzo su richiesta</p>
                <ng-template #notPrivate>
                    <p class="p-0 m-0"
                        routerLink="/{{this.main.generateRouteByContractAndStatus(annuncioObj)}}/{{annuncioObj?.slug}}">
                        <span class="price" [style.color]="annuncioObj?.agency?.color || '#166FC1'">{{annuncioObj?.price
                            | currencyITFormat:'EUR':'€':"1.0-2" }}</span>
                        <ng-container
                            *ngIf="annuncioObj?.contract_type === 'rent' && annuncioObj?.private_negotiation === false">
                            /mese
                        </ng-container>
                    </p>
                </ng-template>
            </ng-container>
            <ng-container *ngIf="this.annuncioObj?.historical">
                <p class="p-0 m-0"
                    routerLink="/{{this.main.generateRouteByContractAndStatus(annuncioObj)}}/{{annuncioObj?.slug}}">
                    <b style="color: #166fc1">ARCHIVIATO</b>
                </p>
            </ng-container>
        </div>
    </div>
</ng-container>